import { render, staticRenderFns } from "./ConversionePremio.vue?vue&type=template&id=1c1ff1e7"
import script from "./ConversionePremio.vue?vue&type=script&lang=js"
export * from "./ConversionePremio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports